import axios from "../helpers/bearerAxios";
import { logger } from "./loggingService";
const baseURL = import.meta.env.VITE_BASE_URL!;

const getMasterDataList = async () => {
  try {
    const response = await axios.get(
      baseURL + import.meta.env.VITE_MASTER_DATA_API_URL
    );
    return response.data;
  } catch (error) {
    logger.error(error);
  }
};
const masterDataServices = {
  getMasterDataList,
};

export default masterDataServices;
